import React from 'react'

const tdStyle = { paddingTop: 2, paddingBottom: 3 }
const namespaceStyle = { fontSize: '.8em' }
const classNameStyle = { paddingTop: 10 }

export function AuditLogServiceName (props) {
  const { dataItem, field } = props
  const value = dataItem[field] || ''
  const index = Math.max(0, value.lastIndexOf('.'))
  const namespace = value.substring(0, index)
  const className = value.substring(index + 1)
  return (
    <td style={tdStyle}>
      <div>
        <span style={namespaceStyle}>{namespace}</span>
        <div><strong style={classNameStyle}>{className}</strong></div>
      </div>
    </td>
  )
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/auditLogs/customCell.js